import { useEffect, useState } from 'react';

export type ViewAsRole = 'dealer' | 'rep' | 'account_manager';

const KEY = 'ak_view_as_role';
const EVENT = 'ak-view-as-change';

export function getViewAs(): ViewAsRole | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'dealer' || v === 'rep' || v === 'account_manager' ? v : null;
  } catch {
    return null;
  }
}

export function setViewAs(role: ViewAsRole | null) {
  try {
    if (role) localStorage.setItem(KEY, role);
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event(EVENT));
}

/**
 * Admin-only UI preview switch. Purely client-side: it changes which
 * navigation/UI an admin sees, it does NOT change database permissions.
 */
export function useViewAs() {
  const [viewAs, setState] = useState<ViewAsRole | null>(() => getViewAs());

  useEffect(() => {
    const sync = () => setState(getViewAs());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return { viewAs, setViewAs };
}
